import { ReactNode, useContext, useEffect } from "react";
import { Row, Stack, ToastContainer } from "react-bootstrap";
import styled from "styled-components";

import StatusContext from "common/store/StatusContext";

import MyAlert from "../atoms/MyAlert";

import Topbar from "../organisms/Topbar";
import Footer from "../organisms/Footer";
import MyToast from "../atoms/MyToast";

type Props = {
  changePassword?: boolean;
  children: ReactNode;
};

export const BasicTemplate = (props: Props) => {
  const { errorMessage, setErrorMessage, toastTitle, toastMessage, toastVariant, setToastMessage } =
    useContext(StatusContext);

  useEffect(() => {
    setErrorMessage("");
  }, [setErrorMessage]);

  return (
    <div>
      <div style={{ zIndex: 3 }}>
        <Topbar changePassword={props.changePassword} />
      </div>
      <ContentRow className="">{props.children}</ContentRow>
      <ToastContainer className="p-3 fixed-top ms-auto" position="top-end" style={{ zIndex: 2 }}>
        {toastMessage && (
          <MyToast
            variant={toastVariant}
            title={toastTitle}
            message={toastMessage}
            onClose={async () => setToastMessage("")}
            duration={3000}
          ></MyToast>
        )}
      </ToastContainer>
      <SMessageStack className="fixed-top py-0">
        {errorMessage && (
          <MyAlert variant="danger" closeRequested={() => setErrorMessage("")}>
            {errorMessage}
          </MyAlert>
        )}
      </SMessageStack>

      <Footer className="fixed-bottom" />
    </div>
  );
};

const ContentRow = styled(Row)`
  margin-left: 10px;
  margin-right: 10px;
`;
const SMessageStack = styled(Stack)`
  margin-top: 56px;
`;
